import Image from 'next/image';
import React, { FC } from 'react';



interface LoadingSpinnerProps { }

const LoadingSpinner: FC<LoadingSpinnerProps> = () => {
  return (
    <div className="fixed inset-0 z-[200] flex flex-col gap-5 items-center justify-center bg-white bg-opacity-75">
     <div className='bg-white rounded-[40px] p-10 pb-10  flex flex-col items-center gap-5 border-gray-50 border-2'>
       <Image
        src="/images/logo-v2.png"
        alt="almuayed"
        width={280}
        height={180}
        className="w-[160px] max-sm:w-48 h-auto  cursor-pointer "
        priority
      />
      <div className="w-12 h-12 border-8 max-sm:w-10 max-sm:h-10 max-sm:border-5 border-primary border-t-secondary rounded-full animate-spin"></div>
      </div>
    </div>
  );
};



export default LoadingSpinner;
